var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('img',{staticStyle:{"display":"block"},attrs:{"src":_vm.data.facade,"alt":_vm.data.name}}),_vm._v(" "),_c('div',{staticClass:"card-bottom"},[_c('h3',[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.phone,"target":"_blank"}},[_vm._v("Contactar")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }